import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/uav.png'
import _imports_1 from '@/assets/images/caac_windDir.png'
import _imports_2 from '@/assets/images/vk_zl_line.png'
import _imports_3 from '@/assets/images/dangerIcon.png'
import _imports_4 from '@/assets/images/alarm.png'
import _imports_5 from '@/assets/images/back.png'
import _imports_6 from '@/assets/images/audioSetting.png'
import _imports_7 from '@/assets/images/audioList.png'
import _imports_8 from '@/assets/images/add.png'
import _imports_9 from '@/assets/images/decrease.png'
import _imports_10 from '@/assets/images/biaopan.png'
import _imports_11 from '@/assets/images/vector.png'
import _imports_12 from '@/assets/images/polygon.png'
import _imports_13 from '@/assets/images/vectorIconL.png'
import _imports_14 from '@/assets/images/vectorIconR.png'
import _imports_15 from '@/assets/images/potionIcon.png'


const _hoisted_1 = { class: "transmit-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "alarm-container" }
const _hoisted_4 = { class: "header caac-header flex-row" }
const _hoisted_5 = { class: "left flex-row" }
const _hoisted_6 = { class: "right header-rt flex-row" }
const _hoisted_7 = { class: "atti-message" }
const _hoisted_8 = { class: "signal-simulation-container" }
const _hoisted_9 = { class: "gale-warning-container atti-message-warning" }
const _hoisted_10 = { class: "fps-container wind-dirct-container" }
const _hoisted_11 = { class: "fps-container" }
const _hoisted_12 = { class: "img-box" }
const _hoisted_13 = { class: "battery-container flex-row mr32" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "connect-status" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "progress-container" }
const _hoisted_18 = { class: "progress-box" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "collision-warning-container" }
const _hoisted_21 = { class: "collision-warning-inner" }
const _hoisted_22 = { class: "collision-warning-levels" }
const _hoisted_23 = { class: "collision-warning-min-distance" }
const _hoisted_24 = { class: "battery-alarm-container" }
const _hoisted_25 = { class: "early-warning alarm-content" }
const _hoisted_26 = { class: "alarm-warning alarm-content" }
const _hoisted_27 = { class: "gale-warning-container have-battery-alarm" }
const _hoisted_28 = { class: "take-picture-video" }
const _hoisted_29 = { class: "bottm-box" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "audio-container" }
const _hoisted_32 = ["id", "src"]
const _hoisted_33 = ["id", "src"]
const _hoisted_34 = {
  key: 2,
  class: "video-time"
}
const _hoisted_35 = {
  key: 0,
  class: "photo-review-box"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "gimbal-pitch-container" }
const _hoisted_38 = { class: "pitch-inner-container" }
const _hoisted_39 = { class: "pitch-scale-container" }
const _hoisted_40 = { class: "scale-text" }
const _hoisted_41 = { class: "zoom-container" }
const _hoisted_42 = { class: "center-box box-content" }
const _hoisted_43 = { class: "zoom-scale" }
const _hoisted_44 = { class: "dial-plate-box" }
const _hoisted_45 = { class: "dial-plate-container" }
const _hoisted_46 = { class: "dial-plate-content" }
const _hoisted_47 = { class: "plate-container" }
const _hoisted_48 = { class: "message-container message-left" }
const _hoisted_49 = { class: "message-content" }
const _hoisted_50 = { class: "message-text first" }
const _hoisted_51 = { class: "font36" }
const _hoisted_52 = { class: "message-text last" }
const _hoisted_53 = { class: "message-container message-right" }
const _hoisted_54 = { class: "message-content" }
const _hoisted_55 = { class: "message-text first" }
const _hoisted_56 = { class: "font36" }
const _hoisted_57 = { class: "message-text last" }
const _hoisted_58 = { class: "stayPos-inner-container" }
const _hoisted_59 = { class: "angle-container" }
const _hoisted_60 = { class: "inner-container" }
const _hoisted_61 = {
  key: 1,
  class: "reference-photos-container"
}
const _hoisted_62 = { class: "reference-photos-inner" }
const _hoisted_63 = ["src"]
const _hoisted_64 = {
  key: 2,
  class: "target-ratio-container"
}
const _hoisted_65 = {
  class: "progress-box",
  id: "targetProgressBox"
}
const _hoisted_66 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_67 = { class: "task-container info-btn" }
const _hoisted_68 = {
  key: 0,
  class: "top-box box-container"
}
const _hoisted_69 = { class: "left-part" }
const _hoisted_70 = { class: "task-name" }
const _hoisted_71 = { class: "right-part" }
const _hoisted_72 = { class: "percentage-value" }
const _hoisted_73 = {
  key: 1,
  class: "bottom-box box-container"
}
const _hoisted_74 = { class: "top-box" }
const _hoisted_75 = { class: "task-type-container" }
const _hoisted_76 = {
  key: 3,
  class: "select-task-container"
}
const _hoisted_77 = { class: "inner-container" }
const _hoisted_78 = { class: "content-container" }
const _hoisted_79 = { class: "title-container" }
const _hoisted_80 = { class: "task-list-container" }
const _hoisted_81 = { class: "task-name" }
const _hoisted_82 = { class: "task-num" }
const _hoisted_83 = { class: "grad-canvas-container" }
const _hoisted_84 = { class: "flying-info" }
const _hoisted_85 = { class: "flying-info-item" }
const _hoisted_86 = { class: "info-box" }
const _hoisted_87 = { class: "progress-box" }
const _hoisted_88 = { class: "flying-info-item" }
const _hoisted_89 = { class: "info-box" }
const _hoisted_90 = { class: "progress-box" }
const _hoisted_91 = {
  key: 1,
  class: "audio-detail-container"
}
const _hoisted_92 = { class: "guide-line-setting" }
const _hoisted_93 = { class: "guide-line-overlay" }
const _hoisted_94 = { class: "cross-line" }
const _hoisted_95 = { class: "grid-line" }
const _hoisted_96 = { class: "center-point" }

import { ref, computed } from 'vue'
import useTransmit from './index'
import AudioDetail from '@/views/audio/index.vue'
import  useMouseHide from '@/hooks/useMouseHide.ts'
import vkmCollisionWarning from '@/components/modules/flight/collisionWarning/index.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {},
  emits: {},
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const audioIconRef = ref<HTMLDivElement | null>(null);
const biaopan = ref<HTMLDivElement | null>(null);
const homePos = ref<HTMLDivElement | null>(null);
const homeIcon = ref<HTMLDivElement | null>(null);
const progressRef = ref<HTMLDivElement | null>(null);
const timeBox = ref<HTMLDivElement | null>(null);
const progressBox = ref<HTMLDivElement | null>(null);
const stayPosRef = ref<HTMLDivElement | null>(null);
const { isMouseHidden } = useMouseHide(3000)

const {
    ///////// 状态
    currentPage,
    PageName,
    sceneImage,
    progressValue,
    receive,
    sum,
    speed,
  currentFile,
  maxFile,
    uavCurrentStatus,
    maxHeight,
    batteryIcon,
    connectIcon,
    battery,
    progressTimer,
    lockIcon,
    uavFlyStatus,
    $enum,
    changeModeIcon,
    videoIcon,
    photoIcon,
    videoStatus,
    photoStatus,
    audioMode,
    takeVideoTime,
    showAudioView,
    photoPic,
    currentZoom,
    scaleMarks,
    zoomPoint,
    dialStyle,
    speedValue,
    relativeAltitude,
    altitudeValue,
    horizontalDistance,
    positionStyle,
    angleValue,
    trainingId,
    onGround,
    lockStatus,
    isShowTaskList,
    guidStatus,
    startCoundow,
    taskList,
    currentTask,
    currentPointIndex,
    currentTaskInfo,
    currentPoint,
    percentage,
    currentSeconds,
    totalSeconds,
    pitchTop,
    pitch,
    fromToAudio,
    isShowAlarm,
    alertType,
    AlertType,
    engineInitialized,
    pageVisible,
    loadingProgess,
    loading3D,
    fpsStatus,
    currentWindSpeed,
    connectStatus,
    isReady,
    FlyMode,
    currentFlyMode,
    alarmType,
    promptText,
    sceneCategory,
    SceneCategory,
    isAlwaysVisibleAi,
    currentMessage,
    MassageType,
    characterMode,
    CharacterMode,
    referencePhoto,
    gradTotalTime,
    crash,
    gradScore,
    evaluate,
    passedPhotoCount,
    completedPhotoCount,
    allPhotoCount,
    loading,
    stayPointStyle,
    targetRatio,
    showTargetProgress,
    standardTargetRatio,
    SignalStrength,
    signalStrength,
    galeWarning,
    collisionWarningLevels,
    collisionWarningMinDistance,
    isAssessmentScene,
    isPilotAssessment,
    ///////// 方法
    handleBack,
    handleBackCallback,
    handleLock,
    handleBackHome,
    handleChangeMode,
    handleTakePhoto,
    handleTakeVideo,
    zoomIn,
    zoomOut,
    getMarkPosition,
    handleSwitch,
    handleRestart,
    handleShowTaskList,
    backFromAudio,
    handleOpenAlbum,
    handleOpenPDF,
    handleSwitchFlyMode,
    speak,
    stop,
    handleDownload,
    handleFinish,
    handleOpenSettingFullscreen,
    handleSwitchSetting,
    settingConfirmLoading,
    settingResetLoading,
    crossLine,
    gridLine,
    centerPoint,
    handleToggleGuideLine,
    handleResetGuideLine,
    handleConfirmGuideLine,
} = useTransmit(emits, audioIconRef,biaopan,homePos,homeIcon,progressRef,timeBox,progressBox,stayPosRef);

const referencePhotoUrl = computed(() => {
    const photo = referencePhoto.value
    if (!photo) return ''
    if (photo.startsWith('data:image')) return photo
    return process.env.VUE_APP_FILE_URL + photo
})

return (_ctx: any,_cache: any) => {
  const _component_vkm_loading3D = _resolveComponent("vkm-loading3D")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_vkm_remoteStatus = _resolveComponent("vkm-remoteStatus")!
  const _component_vkm_aiInstructor = _resolveComponent("vkm-aiInstructor")!
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_vkm_progressBar = _resolveComponent("vkm-progressBar")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_vkm_electricityGrade = _resolveComponent("vkm-electricityGrade")!
  const _component_vkm_sceneSetting = _resolveComponent("vkm-sceneSetting")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(currentPage) == 1)
      ? (_openBlock(), _createBlock(_component_vkm_loading3D, {
          key: 0,
          engineInitialized: _unref(engineInitialized),
          sceneImage: _unref(sceneImage),
          receive: _unref(receive),
          sum: _unref(sum),
          speed: _unref(speed),
          currentFile: _unref(currentFile),
          maxFile: _unref(maxFile),
          progressValue: _unref(loadingProgess),
          title: _unref(loading3D).title,
          description: _unref(loading3D).description,
          pageType: _unref(loading3D).pageType,
          sceneType: "输电"
        }, null, 8, ["engineInitialized", "sceneImage", "receive", "sum", "speed", "currentFile", "maxFile", "progressValue", "title", "description", "pageType"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _unref(isShowAlarm) || (_unref(alertType) == _unref(AlertType).电量告警 && _unref(uavFlyStatus) == _unref($enum).UAV_FLY_STATUS.FLYING) || _unref(currentMessage) == _unref(MassageType).碰撞]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("i", {
            class: "iconfont-line vk_prevleft_line",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleBackCallback)('icon')))
          }),
          _createElementVNode("p", null, _toDisplayString(_unref(uavCurrentStatus)), 1),
          _createElementVNode("p", null, [
            _cache[23] || (_cache[23] = _createTextVNode("高度限制 ")),
            _createElementVNode("span", null, _toDisplayString(_unref(maxHeight)), 1),
            _cache[24] || (_cache[24] = _createTextVNode("m"))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("div", _hoisted_7, _cache[25] || (_cache[25] = [
            _createElementVNode("span", null, "谨慎飞行（姿态模式）", -1)
          ]), 512), [
            [_vShow, _unref(currentFlyMode) == _unref(FlyMode).姿态]
          ]),
          _createElementVNode("div", {
            class: "uav-gis flex-row",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleSwitchFlyMode) && _unref(handleSwitchFlyMode)(...args)))
          }, [
            _cache[26] || (_cache[26] = _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(currentFlyMode) == _unref(FlyMode).GPS?'GPS':'ATTI'), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("i", {
              class: _normalizeClass(['iconfont-line', 'vk_wxh_line', {'vk_wxh_line': _unref(signalStrength) == _unref(SignalStrength).无 , 'vk_dxh_line': _unref(signalStrength) == _unref(SignalStrength).弱, 'vk_qxh_line': _unref(signalStrength) == _unref(SignalStrength).中 || _unref(signalStrength) == _unref(SignalStrength).强}]),
              style: _normalizeStyle({ color: _unref(signalStrength) == _unref(SignalStrength).无?'#A2A6B1':_unref(signalStrength) == _unref(SignalStrength).弱?'#E70102':'#FFFFFF' })
            }, null, 6),
            _withDirectives(_createElementVNode("div", _hoisted_9, _cache[27] || (_cache[27] = [
              _createElementVNode("div", { class: "gale-warning-inner" }, [
                _createElementVNode("div", { class: "gale-warning-content" }, [
                  _createElementVNode("p", null, "GPS信号弱：已自动进入姿态模式，飞行器将不会悬停，请谨慎飞行。")
                ])
              ], -1)
            ]), 512), [
              [_vShow, _unref(signalStrength) == _unref(SignalStrength).无 || _unref(signalStrength) == _unref(SignalStrength).弱]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "img-box" }, [
              _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_1,
                alt: ""
              })
            ], -1)),
            _createElementVNode("p", null, _toDisplayString(_unref(currentWindSpeed)) + "m/s", 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[29] || (_cache[29] = _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_2,
                alt: ""
              }, null, -1)),
              _withDirectives(_createElementVNode("img", {
                class: "denger-icon",
                src: _imports_3,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleOpenPDF) && _unref(handleOpenPDF)(...args))),
                alt: ""
              }, null, 512), [
                [_vShow, _unref(fpsStatus) < 30]
              ])
            ]),
            _createElementVNode("p", null, [
              _cache[30] || (_cache[30] = _createTextVNode("FPS:")),
              _createElementVNode("span", {
                class: _normalizeClass({'danger':_unref(fpsStatus) < 30})
              }, _toDisplayString(_unref(fpsStatus)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: _unref(batteryIcon),
              alt: ""
            }, null, 8, _hoisted_14),
            _createElementVNode("span", null, _toDisplayString(_unref(battery)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: _unref(connectIcon),
              style: {"margin-left":"0px"},
              alt: ""
            }, null, 8, _hoisted_16)
          ]),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "设置",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "iconfont-fill vk_sz_fill header-icon",
                style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : !_unref(isReady) ? 'not-allowed !important' : 'pointer !important' }),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(handleOpenSettingFullscreen)(_unref(isReady))))
              }, null, 4)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "辅助线设置",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "iconfont-line vk_more_line header-icon",
                style: _normalizeStyle({ cursor: _unref(isMouseHidden)? 'none !important' : !_unref(isReady)? 'not-allowed !important' : 'pointer !important' }),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(handleSwitchSetting)('open')))
              }, null, 4)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          ref_key: "progressBox",
          ref: progressBox,
          class: "progress-content"
        }, [
          _cache[34] || (_cache[34] = _createElementVNode("img", {
            class: "alarm",
            src: _imports_4,
            alt: ""
          }, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(_unref(currentSeconds) < _unref(totalSeconds) && _unref(pageVisible)?'animation-time time-container':'time-container'),
            ref_key: "timeBox",
            ref: timeBox
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(progressTimer)), 1)
          ], 2),
          _createElementVNode("div", _hoisted_18, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "dvl" }, null, -1)),
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "dv2" }, null, -1)),
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "dv3" }, null, -1)),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(currentSeconds) < _unref(totalSeconds) && _unref(pageVisible)?'dv4-animation dv4':'dv4'),
              ref_key: "progressRef",
              ref: progressRef
            }, null, 2)
          ])
        ], 512)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(lockStatus) == _unref($enum).CommonStatus.open && !_unref(onGround)?'none-click-btn lock-container':'lock-container' ),
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(handleLock) && _unref(handleLock)(...args)))
      }, [
        _createElementVNode("img", {
          src: _unref(lockIcon),
          alt: ""
        }, null, 8, _hoisted_19)
      ], 2),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(vkmCollisionWarning, { levels: _unref(collisionWarningLevels) }, null, 8, ["levels"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", null, _toDisplayString(_unref(collisionWarningMinDistance)) + "m", 1)
          ], 512), [
            [_vShow, _unref(collisionWarningMinDistance)]
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(uavFlyStatus) == _unref($enum).UAV_FLY_STATUS.WAITING || _unref(galeWarning) || _unref(battery) < 12 ?'none-click-btn back-container btn-main-style':'back-container btn-main-style'),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(handleBackHome)(false)))
      }, _cache[35] || (_cache[35] = [
        _createElementVNode("img", {
          src: _imports_5,
          alt: ""
        }, null, -1)
      ]), 2),
      _createElementVNode("div", _hoisted_24, [
        _withDirectives(_createElementVNode("div", _hoisted_25, " 电量不足请返航 ", 512), [
          [_vShow, _unref(battery) < 20 && _unref(battery) >= 12 && _unref(uavFlyStatus) == _unref($enum).UAV_FLY_STATUS.FLYING]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_26, " 电量严重不足，10秒后自动返航 ", 512), [
          [_vShow, _unref(battery) < 12 && _unref(uavFlyStatus) == _unref($enum).UAV_FLY_STATUS.FLYING]
        ])
      ]),
      _createVNode(_component_vkm_remoteStatus, {
        isRemoteConnected: !!_unref(connectStatus),
        isReady: _unref(isReady),
        style: { zIndex: 10 }
      }, null, 8, ["isRemoteConnected", "isReady"]),
      _withDirectives(_createElementVNode("div", _hoisted_27, _cache[36] || (_cache[36] = [
        _createElementVNode("div", { class: "gale-warning-inner" }, [
          _createElementVNode("div", { class: "gale-warning-content" }, [
            _createElementVNode("p", null, "飞机遭遇强风，无法完成自动返航，请谨慎飞行")
          ])
        ], -1)
      ]), 512), [
        [_vShow, _unref(galeWarning)]
      ]),
      (_unref(sceneCategory) == _unref(SceneCategory).训练)
        ? (_openBlock(), _createBlock(_component_vkm_aiInstructor, {
            key: 0,
            alarmType: _unref(alarmType),
            isMouseHidden: _unref(isMouseHidden),
            promptText: _unref(promptText),
            speak: _unref(speak),
            stop: _unref(stop),
            isAlwaysVisible: _unref(isAlwaysVisibleAi)
          }, null, 8, ["alarmType", "isMouseHidden", "promptText", "speak", "stop", "isAlwaysVisible"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", {
          class: "top-box",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(handleShowTaskList) && _unref(handleShowTaskList)(...args)))
        }, _cache[37] || (_cache[37] = [
          _createElementVNode("img", {
            class: "size64",
            src: _imports_6,
            alt: ""
          }, null, -1)
        ])),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("img", {
            class: _normalizeClass(_unref(uavFlyStatus) != _unref($enum).UAV_FLY_STATUS.FLYING?'none-click size64':'size64'),
            src: _unref(changeModeIcon),
            alt: "",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(handleChangeMode) && _unref(handleChangeMode)(...args)))
          }, null, 10, _hoisted_30),
          _createElementVNode("div", _hoisted_31, [
            (_unref(audioMode) == _unref($enum).AUDIO_MODE.PHOTO)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  id: _unref(uavFlyStatus) != _unref($enum).UAV_FLY_STATUS.FLYING?'no-click':'',
                  class: _normalizeClass(_unref(photoStatus) == _unref($enum).CommonStatus.open?'takeing-photo photo-icon':'photo-icon'),
                  src: _unref(photoIcon),
                  alt: "",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(handleTakePhoto) && _unref(handleTakePhoto)(...args)))
                }, null, 10, _hoisted_32))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  id: _unref(uavFlyStatus) != _unref($enum).UAV_FLY_STATUS.FLYING?'no-click':'',
                  src: _unref(videoIcon),
                  alt: "",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(handleTakeVideo) && _unref(handleTakeVideo)(...args)))
                }, null, 8, _hoisted_33)),
            (_unref(videoStatus) == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_unref(takeVideoTime)), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "size64 audio-icon",
            ref_key: "audioIconRef",
            ref: audioIconRef
          }, [
            (_unref(showAudioView))
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("img", {
                    src: _unref(photoPic)?_unref(photoPic):'',
                    alt: ""
                  }, null, 8, _hoisted_36)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              class: "audioList",
              src: _imports_7,
              alt: "",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(handleOpenAlbum) && _unref(handleOpenAlbum)(...args)))
            })
          ], 512)
        ])
      ], 512), [
        [_vShow, _unref(characterMode) == _unref(CharacterMode).图传视角]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "pitch-btn" }, null, -1)),
          _createElementVNode("div", _hoisted_39, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(15), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "scale-item",
                key: item
              }))
            }), 128)),
            _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(pitch).toFixed(0)) + "°", 1),
            _createElementVNode("div", {
              class: "scale-box",
              style: _normalizeStyle({bottom:_unref(pitchTop)})
            }, null, 4)
          ]),
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "pitch-btn" }, null, -1))
        ])
      ], 512), [
        [_vShow, _unref(characterMode) == _unref(CharacterMode).图传视角]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", {
          class: _normalizeClass(_unref(uavFlyStatus) != _unref($enum).UAV_FLY_STATUS.FLYING?'none-click-btn top-box box-content':'top-box box-content'),
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_unref(zoomIn) && _unref(zoomIn)(...args)))
        }, _cache[40] || (_cache[40] = [
          _createElementVNode("img", {
            src: _imports_8,
            alt: ""
          }, null, -1)
        ]), 2),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scaleMarks), (mark) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "scale-mark",
                key: mark,
                style: _normalizeStyle({ top: _unref(getMarkPosition)(mark) + '%' })
              }, null, 4))
            }), 128)),
            _createElementVNode("div", {
              class: "zoom-content",
              style: _normalizeStyle({ top: _unref(zoomPoint)})
            }, [
              _cache[41] || (_cache[41] = _createElementVNode("span", null, "Zoom", -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(currentZoom).toFixed(1)) + "X", 1)
            ], 4)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(uavFlyStatus) != _unref($enum).UAV_FLY_STATUS.FLYING?'none-click-btn bottom-box box-content':'bottom-box box-content'),
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(zoomOut) && _unref(zoomOut)(...args)))
        }, _cache[42] || (_cache[42] = [
          _createElementVNode("img", {
            src: _imports_9,
            alt: ""
          }, null, -1)
        ]), 2)
      ], 512), [
        [_vShow, _unref(characterMode) == _unref(CharacterMode).图传视角]
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("img", {
                style: _normalizeStyle(_unref(dialStyle)),
                ref_key: "biaopan",
                ref: biaopan,
                class: "biaopan",
                src: _imports_10,
                alt: ""
              }, null, 4),
              _cache[47] || (_cache[47] = _createElementVNode("img", {
                class: "vector",
                src: _imports_11,
                alt: ""
              }, null, -1)),
              _cache[48] || (_cache[48] = _createElementVNode("img", {
                class: "polygon",
                src: _imports_12,
                alt: ""
              }, null, -1)),
              _cache[49] || (_cache[49] = _createElementVNode("img", {
                class: "vectorIconL",
                src: _imports_13,
                alt: ""
              }, null, -1)),
              _cache[50] || (_cache[50] = _createElementVNode("img", {
                class: "vectorIconR",
                src: _imports_14,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _cache[43] || (_cache[43] = _createElementVNode("p", { class: "font16" }, [
                      _createElementVNode("span", null, "SPD"),
                      _createElementVNode("span", null, "m/s")
                    ], -1)),
                    _createElementVNode("p", _hoisted_51, _toDisplayString(_unref(speedValue)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_52, [
                    _cache[44] || (_cache[44] = _createElementVNode("span", null, "H", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(relativeAltitude)) + "m", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("p", _hoisted_56, _toDisplayString(_unref(altitudeValue)), 1),
                    _cache[45] || (_cache[45] = _createElementVNode("p", { class: "font16" }, [
                      _createElementVNode("span", null, "ALT"),
                      _createElementVNode("span", null, "m")
                    ], -1))
                  ]),
                  _createElementVNode("p", _hoisted_57, [
                    _cache[46] || (_cache[46] = _createElementVNode("span", null, "D", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(horizontalDistance)) + "m", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", {
                ref_key: "homePos",
                ref: homePos,
                class: "position-container"
              }, [
                _createElementVNode("img", {
                  ref_key: "homeIcon",
                  ref: homeIcon,
                  style: _normalizeStyle(_unref(positionStyle)),
                  src: _imports_15,
                  alt: ""
                }, null, 4)
              ], 512),
              _createElementVNode("div", {
                ref_key: "stayPosRef",
                ref: stayPosRef,
                class: "stayPos-container"
              }, [
                _createElementVNode("div", _hoisted_58, [
                  (_unref(isReady))
                    ? (_openBlock(), _createBlock(_component_vkm_svg, {
                        key: 0,
                        id: "stayPosIcon",
                        style: _normalizeStyle(_unref(stayPointStyle)),
                        "icon-name": "pointPos",
                        class: "icon"
                      }, null, 8, ["style"]))
                    : _createCommentVNode("", true)
                ])
              ], 512)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("span", null, _toDisplayString(_unref(angleValue)), 1)
              ])
            ])
          ])
        ])
      ]),
      (_unref(sceneCategory) == _unref(SceneCategory).训练 && _unref(referencePhoto) && _unref(guidStatus) == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "reference-photos-title" }, [
                _createElementVNode("span", null, "参考照片")
              ], -1)),
              _createElementVNode("img", {
                src: referencePhotoUrl.value,
                alt: ""
              }, null, 8, _hoisted_63)
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(showTargetProgress))
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", {
              class: _normalizeClass(["inner-container", _unref(targetRatio) < _unref(standardTargetRatio)?'note-standard inner-container':'standard inner-container'])
            }, [
              _createElementVNode("div", _hoisted_65, [
                _createVNode(_component_vkm_progressBar, {
                  "initial-progress": _unref(targetRatio),
                  step: 1,
                  standardTargetRatio: _unref(standardTargetRatio)
                }, null, 8, ["initial-progress", "standardTargetRatio"])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(['uav-actions-container', _unref(isAssessmentScene)?'exam-mode-container':''])
      }, [
        (!_unref(isAssessmentScene))
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              (_unref(sceneCategory) == _unref(SceneCategory).训练)
                ? (_openBlock(), _createBlock(_component_vkn_button, {
                    key: 0,
                    label: _unref(guidStatus) == 1?'关闭引导':'开启引导',
                    type: "tertiary",
                    size: "medium",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(handleSwitch)('guid')))
                  }, {
                    icon: _withCtx(() => _cache[52] || (_cache[52] = [
                      _createElementVNode("i", { class: "iconfont-line vk_jz_line1" }, null, -1)
                    ])),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_vkn_button, {
                class: "insert-btn",
                label: "视角",
                type: "tertiary",
                size: "medium",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(handleSwitch)('view')))
              }, {
                icon: _withCtx(() => _cache[53] || (_cache[53] = [
                  _createElementVNode("i", { class: "iconfont-line vk_qh_line" }, null, -1)
                ])),
                _: 1
              }),
              (_unref(sceneCategory) == _unref(SceneCategory).训练)
                ? (_openBlock(), _createBlock(_component_vkn_button, {
                    key: 1,
                    label: "重置",
                    type: "tertiary",
                    size: "medium",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(handleSwitch)('reset')))
                  }, {
                    icon: _withCtx(() => _cache[54] || (_cache[54] = [
                      _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_67, [
          (_unref(taskList).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _cache[55] || (_cache[55] = _createElementVNode("p", { class: "task-type" }, "巡检任务", -1)),
                  _createElementVNode("p", _hoisted_70, _toDisplayString(_unref(currentTaskInfo)?.airLineName), 1),
                  _createElementVNode("p", null, "巡检状态   " + _toDisplayString(_unref(currentPointIndex)) + "/" + _toDisplayString(_unref(currentTaskInfo)?.pointList.length), 1)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_el_progress, {
                    type: "circle",
                    percentage: _unref(percentage),
                    color: "#4382E3"
                  }, {
                    default: _withCtx(({ percentage }) => [
                      _createElementVNode("span", _hoisted_72, _toDisplayString(percentage) + "%", 1),
                      _cache[56] || (_cache[56] = _createElementVNode("span", { class: "percentage-label" }, "进度", -1))
                    ]),
                    _: 1
                  }, 8, ["percentage"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(taskList).length > 0 && !_unref(isAssessmentScene))
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _cache[57] || (_cache[57] = _createElementVNode("p", { class: "type-text" }, "巡检要求", -1)),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("p", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['type-card',  _unref(currentPoint)?.shootAngle == '平视'?'green':_unref(currentPoint)?.shootAngle == '俯视'?'orange':'brand'])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(currentPoint)?.shootAngle?_unref(currentPoint)?.shootAngle:'--'), 1)
                      ], 2),
                      _createTextVNode(" " + _toDisplayString(_unref(currentPoint)?.actionName), 1)
                    ])
                  ])
                ]),
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "btn-box" }, null, -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (_unref(isShowTaskList))
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _cache[59] || (_cache[59] = _createElementVNode("p", null, "选择任务", -1)),
                  _createElementVNode("i", {
                    class: "iconfont-line vk_gb_line1",
                    onClick: _cache[17] || (_cache[17] = ()=>{isShowTaskList.value = false})
                  })
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_el_scrollbar, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taskList), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(index == _unref(currentTask)?'active-item task-item':'task-item'),
                          key: index
                        }, [
                          _createElementVNode("p", _hoisted_81, _toDisplayString(item?.airLineName), 1),
                          _createElementVNode("p", _hoisted_82, "点位数量 " + _toDisplayString(item?.pointList.length), 1)
                        ], 2))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _unref(currentPage) == _unref(PageName).飞行]
    ]),
    _withDirectives(_createVNode(_component_vkm_electricityGrade, {
      style: {"z-index":"2200"},
      gradTotalTime: _unref(gradTotalTime),
      crash: _unref(crash),
      gradScore: _unref(gradScore),
      evaluate: _unref(evaluate),
      coundownStatus: _unref(startCoundow),
      showDownload: true,
      loading: _unref(loading),
      isShowRestart: !_unref(isPilotAssessment),
      onOnBack: _unref(handleBackCallback),
      onOnRestart: _unref(handleRestart),
      onOnDownload: _unref(handleDownload)
    }, {
      gradCanvas: _withCtx(() => [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", {
            class: "inner",
            onClick: _cache[18] || (_cache[18] = ()=>{currentPage.value = _unref(PageName).音频;fromToAudio.value = _unref(PageName).成绩;startCoundow.value = false;})
          }, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "showFiles",
              class: "icon"
            }),
            _cache[60] || (_cache[60] = _createElementVNode("span", null, "查看结果", -1))
          ])
        ])
      ]),
      flyInfo: _withCtx(() => [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _cache[61] || (_cache[61] = _createElementVNode("span", null, "完成总数", -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(completedPhotoCount)) + " / " + _toDisplayString(_unref(allPhotoCount)), 1)
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", {
                class: "progress-inner",
                style: _normalizeStyle({width:(_unref(completedPhotoCount) /  _unref(allPhotoCount) )*100+'%',backgroundColor:_unref(completedPhotoCount) < _unref(allPhotoCount)? '#C60B12':'#2174FF'})
              }, null, 4)
            ])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _cache[62] || (_cache[62] = _createElementVNode("span", null, "合格照片数", -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(passedPhotoCount)) + " / " + _toDisplayString(_unref(allPhotoCount)), 1)
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", {
                class: "progress-inner",
                style: _normalizeStyle({width:(_unref(passedPhotoCount) /  _unref(allPhotoCount) )*100+'%',backgroundColor:_unref(passedPhotoCount) < _unref(allPhotoCount)? '#C60B12':'#2174FF'})
              }, null, 4)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["gradTotalTime", "crash", "gradScore", "evaluate", "coundownStatus", "loading", "isShowRestart", "onOnBack", "onOnRestart", "onOnDownload"]), [
      [_vShow, _unref(currentPage) == _unref(PageName).成绩]
    ]),
    (_unref(currentPage) == _unref(PageName).音频)
      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
          _createVNode(AudioDetail, {
            trainId: _unref(trainingId),
            onOnBack: _unref(backFromAudio)
          }, null, 8, ["trainId", "onOnBack"])
        ]))
      : _createCommentVNode("", true),
    (_unref(currentPage) == _unref(PageName).辅助线)
      ? (_openBlock(), _createBlock(_component_vkm_sceneSetting, {
          key: 2,
          title: "设置",
          resetLoading: _unref(settingResetLoading),
          confirmLoading: _unref(settingConfirmLoading),
          onOnClose: _cache[22] || (_cache[22] = ($event: any) => (_unref(handleSwitchSetting)('close'))),
          onOnReset: _unref(handleResetGuideLine),
          onOnConfirm: _unref(handleConfirmGuideLine)
        }, {
          default: _withCtx(() => [
            _cache[66] || (_cache[66] = _createElementVNode("div", { class: "option-title-container" }, [
              _createElementVNode("span", null, "辅助线设置"),
              _createElementVNode("span", null, "可多选")
            ], -1)),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("div", {
                class: _normalizeClass(['guide-line-card', _unref(crossLine) ? 'active' : '']),
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(handleToggleGuideLine)('cross')))
              }, _cache[63] || (_cache[63] = [
                _createElementVNode("div", { class: "preview cross-preview" }, [
                  _createElementVNode("div", { class: "preview-box" }, [
                    _createElementVNode("div", { class: "line diagonal-1" }),
                    _createElementVNode("div", { class: "line diagonal-2" })
                  ])
                ], -1),
                _createElementVNode("span", null, "交叉线", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass(['guide-line-card', _unref(gridLine) ? 'active' : '']),
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(handleToggleGuideLine)('grid')))
              }, _cache[64] || (_cache[64] = [
                _createElementVNode("div", { class: "preview grid-preview" }, [
                  _createElementVNode("div", { class: "preview-box" }, [
                    _createElementVNode("div", {
                      class: "line grid-h",
                      style: {"top":"33.33%"}
                    }),
                    _createElementVNode("div", {
                      class: "line grid-h",
                      style: {"top":"66.66%"}
                    }),
                    _createElementVNode("div", {
                      class: "line grid-v",
                      style: {"left":"33.33%"}
                    }),
                    _createElementVNode("div", {
                      class: "line grid-v",
                      style: {"left":"66.66%"}
                    })
                  ])
                ], -1),
                _createElementVNode("span", null, "九宫格", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass(['guide-line-card', _unref(centerPoint) ? 'active' : '']),
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_unref(handleToggleGuideLine)('center')))
              }, _cache[65] || (_cache[65] = [
                _createElementVNode("div", { class: "preview center-preview" }, [
                  _createElementVNode("div", { class: "preview-box" }, [
                    _createElementVNode("div", { class: "line horizontal" }),
                    _createElementVNode("div", { class: "line vertical" })
                  ])
                ], -1),
                _createElementVNode("span", null, "中心点", -1)
              ]), 2)
            ])
          ]),
          _: 1
        }, 8, ["resetLoading", "confirmLoading", "onOnReset", "onOnConfirm"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_93, [
      _withDirectives(_createElementVNode("div", _hoisted_94, _cache[67] || (_cache[67] = [
        _createElementVNode("div", { class: "line diagonal-1" }, null, -1),
        _createElementVNode("div", { class: "line diagonal-2" }, null, -1)
      ]), 512), [
        [_vShow, _unref(crossLine) && _unref(isReady) && _unref(characterMode) == _unref(CharacterMode).图传视角]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_95, _cache[68] || (_cache[68] = [
        _createElementVNode("div", {
          class: "line grid-h",
          style: {"top":"33.33%"}
        }, null, -1),
        _createElementVNode("div", {
          class: "line grid-h",
          style: {"top":"66.66%"}
        }, null, -1),
        _createElementVNode("div", {
          class: "line grid-v",
          style: {"left":"33.33%"}
        }, null, -1),
        _createElementVNode("div", {
          class: "line grid-v",
          style: {"left":"66.66%"}
        }, null, -1)
      ]), 512), [
        [_vShow, _unref(gridLine) && _unref(isReady) && _unref(characterMode) == _unref(CharacterMode).图传视角]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_96, _cache[69] || (_cache[69] = [
        _createElementVNode("div", { class: "line horizontal" }, null, -1),
        _createElementVNode("div", { class: "line vertical" }, null, -1)
      ]), 512), [
        [_vShow, _unref(centerPoint) && _unref(isReady) && _unref(characterMode) == _unref(CharacterMode).图传视角]
      ])
    ], 512), [
      [_vShow, _unref(currentPage) == _unref(PageName).飞行 || _unref(currentPage) == _unref(PageName).辅助线]
    ])
  ]))
}
}

})